var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PageTitle',{attrs:{"title":"Pages"}}),_c('ApiDataTable',{ref:"dataTable",attrs:{"data-api":"pages","can-insert":true,"can-update":true,"can-delete":true,"row-buttons":[
      { title: 'Preview', icon: 'mdi-magnify' },
      { title: 'Design', icon: 'mdi-monitor-edit' },
      { title: 'Copy', icon: 'mdi-content-copy' } ]},on:{"row-button-click":_vm.rowButtonClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }